<template>
  <div class="contents contents--list">
    <div class="contents--list-subject">
      <span>Blocks</span>
      <RecordSelectBox :record="record" @changeRecord="changeRecord" />
    </div>

    <div class="search-box">
      <div class="search-inner-box">
        <div class="option option--datetime">
          <label>From (UTC +0)</label>
          <Datetime
            v-model="searchFilter.from_time"
            input-id="search_from_time"
            type="datetime"
            zone="UTC"
            minute-step="5"
            input-style="padding:0; width:100%; border:none; color:#333; font-family: Spoqa Han Sans;"
          />
        </div>
        <div class="option option--datetime">
          <label>To (UTC +0)</label>
          <Datetime
            v-model="searchFilter.to_time"
            input-id="search_to_time"
            type="datetime"
            zone="UTC"
            minute-step="5"
            input-style="padding:0; width:100%; border:none; color:#333; font-family: Spoqa Han Sans;"
          />
          <button title="search blocks" @click="search">
            <img src="../../assets/img/magnifier.svg" alt="Search" />
          </button>
          <button
            v-if="this.from_time || this.to_time"
            title="reset time filter"
            @click="reset_timefilter"
          >
            <img src="../../assets/img/menu-cancel.svg" alt="Reset" />
          </button>
        </div>
      </div>
    </div>

    <div v-if="noResults && !loading" class="no-result-msg">
      No Results.
    </div>
    <Table v-if="!noResults" width="900px" data-type="blocks" page="detail" :data="blocks" />

    <Pagination
      v-if="!noResults"
      :isDetail="false"
      :minID="min_no"
      :maxID="max_no"
      :lastID="last_no"
      :currentID="current_no"
      :firstPage="(this.current_no == this.max_no)"
      :lastPage="(this.last_no == this.min_no)"
      :loading="loading"
      @flip="pageCall"
    />
  </div>
</template>

<script>
import RecordSelectBox from "./shared/RecordSelectBox.vue";
import Table from "./shared/Table.vue";
import Pagination from "./shared/Pagination.vue";
import { Datetime } from "vue-datetime";
import callAPI from "../../api/http";
import { convertAttrFormat } from "../../js/format";
import { RecordOptions } from "../../js/fields";
import { styleNav } from "../../js/style";

export default {
  name: "BlocksList",

  props: {
    from_time: {
      type: String,
      default: undefined,
    },
    to_time: {
      type: String,
      default: undefined,
    },
    bookmark: {
      type: Number,
      default: undefined,
    },
    pagesize: {
      type: Number,
      default: RecordOptions[1],
    },
    direction: {
      type: String,
      default: "first",
    },
  },

  components: {
    RecordSelectBox,
    Table,
    Pagination,
    Datetime,
  },

  computed: {
    query() {
      return {
        bookmark: this.bookmark,
        pagesize: this.pagesize,
        direction: this.direction,
        from_time: this.searchFilter.from_time
          ? this.searchFilter.from_time
          : undefined,
        to_time: this.searchFilter.to_time
          ? this.searchFilter.to_time
          : undefined,
      };
    },

    searchFilter() {
      return {
        from_time: this.from_time,
        to_time: this.to_time,
      };
    },
    noResults() {
      return (this.blockslen == 0)
    },
  },

  async beforeRouteUpdate({ query }, from, next) {
    this.bookmark = query.bookmark || 0;
    this.pagesize = query.pagesize || RecordOptions[1];
    this.direction = query.direction || "first";
    this.from_time = query.from_time;
    this.to_time = query.to_time;
    this.record = this.pagesize;
    await this.getBlocks();

    next();
  },

  async created() {
    this.record = this.pagesize;
    await this.getBlocks();
  },

  mounted() {
    styleNav(2);
  },

  data() {
    return {
      blocks: null,
      blockslen: 0,
      loading: false,
      min_no: 0,
      max_no: 0,
      last_no: 0,
      current_no: 0,
    };
  },

  methods: {
    async getBlocks() {
      this.loading = true;
      const { data, errCode } = await callAPI("getBlocks", this.query);
      this.setBlocks(data, errCode);
    },

    pageCall(direction) {
      switch (direction) {
        case "next":
          this.bookmark = this.blocks[this.blocks.length - 1].block_number;
          this.direction = direction;
          break;
        case "prev":
          this.bookmark = this.blocks[0].block_number;
          this.direction = direction;
          break;
        default:
          this.bookmark = undefined;
          this.direction = direction;
      }
      this.route();
    },

    changeRecord(pagesize) {
      if (this.pagesize === pagesize) {
        return;
      }
      this.pagesize = pagesize;
      this.route();
    },

    route() {
      this.$router
        .push({ path: "/blocks", query: this.query })
        .catch((err) => console.log(err));
    },

    search() {
      if (new Date(this.query.from_time) > new Date(this.query.to_time)) {
        alert("From date should be less then To date.");
        return;
      }

      if (!this.searchFilter.from_time && !this.searchFilter.to_time) {
        return;
      }

      if (this.searchFilter.from_time == this.query.from_time && this.searchFilter.to_time == this.query.to_time) {
        return;
      }

      this.query.bookmark = undefined;
      this.query.direction = "first";
      this.query.from_time = this.searchFilter.from_time
        ? this.searchFilter.from_time
        : undefined;
      this.query.to_time = this.searchFilter.to_time
        ? this.searchFilter.to_time
        : undefined;
      this.loading = true;
      this.route();
    },

    reset_timefilter() {
      this.searchFilter.from_time = "";
      this.searchFilter.to_time = "";
      this.query.from_time = undefined;
      this.query.to_time = undefined;
      this.query.bookmark = undefined;
      this.query.direction = "first";
      this.route();
    },

    setBlocks(data, errCode) {
      if (errCode) {
        console.log(errCode);
        this.blockslen = 0;
        this.loading = false;
        return;
      }
      const { blocks, min_no, current_no, max_no } = data;

      if (blocks) {
        this.blocks = convertAttrFormat("BlocksList", blocks);
        this.min_no = min_no;
        this.max_no = max_no;
        this.blockslen = blocks.length;
        this.current_no = current_no
        this.last_no = blocks[blocks.length-1].block_number;
      } else {
        this.blockslen = 0;
      }
      this.loading = false;
    },
  },
};
</script>

<style scoped lang="scss">
.search-box {
  overflow-x: auto;
}

.search-inner-box {
  min-width: 550px;
  height: 100px;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  padding: 10px 0;
  border-top: 1px solid #ebebeb;
  border-bottom: 1px solid #ebebeb;
  margin-top: 15px;

  .option {
    display: flex;
    align-items: center;
  }

  .option label {
    flex: none;
    min-width: 115px;
    white-space: nowrap;
    font-size: 13px;
    font-weight: 700;
  }

  .option--datetime {
    display: flex;
    span {
      margin: 0 8px;
      font-weight: 500;
    }
  }

  .vdatetime {
    width: 200px;
    height: 25px;
    padding: 0 8px;
    display: flex;
    box-sizing: border-box;
    border: 1px solid #ebebeb;
    border-radius: 10px;
  }

  button {
    margin-left: 10px;
    height: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    border-radius: 10px;
    background-color: #0393f4;
    cursor: pointer;
  }

  button > img {
    width: 80%;
    height: auto;
  }
}

.no-result-msg {
  padding-top: 15px;
  display: flex;
  justify-content: center;
  font-size: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/contents/BlocksList.vue